export const arrayToChunks = (array: any[], chunkSize: number = 2) => {
  const newArray = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    newArray.push(array.slice(i, i + chunkSize));
  }
  return newArray;
};
